import { Join, Space } from '@gousto-internal/citrus-react'
import React, { useEffect, useRef, useState } from 'react'
import { OrderTabItem } from './OrderTabItem'
import type { OrderTab, OrderTabState } from './OrderTabs.types'
import { getInitialTabs, setActiveTab } from './OrderTabs.utils'

type OrderTabsProps = {
  orderTabs: OrderTab[]
}
export type { OrderTab } from './OrderTabs.types'

export function OrderTabs({ orderTabs }: OrderTabsProps) {
  // Use a function initializer so the initial tabs mapping only runs on the first render.
  const [tabs, setTabs] = useState(() => getInitialTabs(orderTabs))
  // Track the first effect run so we do not reinitialize tabs immediately after mount.
  const hasMountedRef = useRef(false)

  useEffect(() => {
    if (!hasMountedRef.current) {
      hasMountedRef.current = true

      return
    }

    setTabs(getInitialTabs(orderTabs))
  }, [orderTabs])

  const activateTab = (activeIndex: number) => {
    setTabs((currentTabs) => setActiveTab(currentTabs, activeIndex))
  }

  return (
    <Join with={<Space size={4} />}>
      {tabs.map((tab: OrderTabState, index: number) => (
        <OrderTabItem key={tab.date_title} index={index} tab={tab} onActivate={activateTab} />
      ))}
    </Join>
  )
}
